












































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import api, { AddMarksApi }  from './api';
import markList from './mark-list';
import UiButton from '@/components/ui/ui-button.vue';
import MainMenuComplexTabsMixin from '@/views/layout/navigation/mixins/main-menu-complex-tabs-mixin';

@Component
  export default class AddMarks extends mixins(MainMenuComplexTabsMixin) {
    api: AddMarksApi = api;

    items = markList;
    
    planLimitsType(type){
      switch (type){
        case 'campaigns':
          return 'markersCampaigns'
        case 'offers':
          return 'markersOffers'
        case 'landings':
          return 'markersLandings'
        case 'flows':
          return 'markersFlows'
        case 'affiliate-networks':
          return 'markersAffiliateNetworks'
        case 'traffic-sources':
          return 'markersTrafficSources'
      }
    }
    
    get planLimits(): string | boolean {
      if(this.$route.params?.type?.includes('custom')) return 'markersCustomParams';
      
      if(this.$store.state.table.queryTemporary.view==='tree' && this.$store.state.table.selectedItems.length===1){
        const path = this.$store.state.table.selectedItems[0]?.grouping.replace('-name', '').replace('_', '-') // affiliate_networks-name -> affiliate-networks
        return this.planLimitsType(path)
      }
      return this.planLimitsType(this.$route.params.type)
    }
    
    get isDisabled(){
      return !this.hasSelectedItem || 
        this.isReport() &&
        !this.campaignAsFirstTableFilterCondition &&
        this.$route.params?.type?.includes('custom')
    }

    get filteredSelectedItems() {
      return this.$store.state.table.selectedItems
        ? this.$store.state.table.selectedItems.filter(({ DT_RowId }) => DT_RowId !== 'Unknown')
        : [];
    }
    get customValues(): string[] {
      return this.filteredSelectedItems.map((e: any) => e.DT_RowId).filter(({ isDirect }) => !isDirect);
    }

    get hasSelectedItem() {
      const { grouping } = this.filteredSelectedItems.length === 1 && this.filteredSelectedItems[0]

      if (grouping) {
        const path = grouping.replace('-name', '').replace('_', '-') // affiliate_networks-name -> affiliate-networks
 
        return ['campaigns', 'offers', 'landings', 'flows', 'traffic-sources', 'affiliate-networks'].includes(path) ||
          path.includes('reports-custom')
      }

      return !!this.customValues.length
    }

    get tableDrilldownValues() {
      return this.$store.state.table.drilldownFilter.reduce(( acc, { filterValues }) => {
        acc = acc.concat(filterValues.split('^'))
        return acc
      },[])
    }

    addCustomMark(mark, type = this.$route.params.type) {
      const form: Bemob.CustomMark = {
        mark,
        customParameter: type,
        customValues: this.customValues,
        ids: this.tableDrilldownValues,
      };

      this.api.put(form).then(() => {
        this.bus.emit('marks-added', form);
      });
    }

    addBasicMark(mark, path = this.$route.params.type) {
      const form: Bemob.CustomMarkBase = {
        mark: mark,
        ids: this.customValues
      }

      this.api.putBasic(path, form).then(() => {
        this.bus.emit('marks-added', form);
      });
    }

    handleMarkClick(mark?: number) {
      const menuBtn = this.$refs['menu-button'] as UiButton

      if (!this.hasSelectedItem) return

      menuBtn?.toggleMenu()

      if(this.filteredSelectedItems[0]?.grouping?.startsWith('reports-custom')) {
        return this.addCustomMark(mark, this.filteredSelectedItems[0].grouping.replace('reports-', ''))
      }

      const { grouping } = this.filteredSelectedItems.length === 1 && this.filteredSelectedItems[0]

      if (grouping) {
        const path = grouping.replace('-name', '').replace('_', '-') // affiliate_networks-name -> affiliate-networks
        this.addBasicMark(mark, path)
      } else if (this.isMainTab) {
        return this.addBasicMark(mark)
      }
    }
  }

